import React, { useState, useEffect } from 'react';
import efn from './SubmissionPaperDetailPageFns.js'
import SubmissionPaperAdminAccept from './SubmissionPaperAdminAccept.js'
import SubmissionPaperAdminReEditAccept from './SubmissionPaperAdminReEditAccept.js' 
import SubmissionPaperAdminReviewerSetting from './SubmissionPaperAdminReviewerSetting.js'
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import statusCode from '../../../../enum/submissionPaperStatusEnum.js'
import { Spin, Form, Typography, Tag, Select, Input, Button, Row, Col } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const SubmissionPaperDetailPage = (props) => {
  const [form] = Form.useForm();
  const [reEditForm] = Form.useForm();
  const [isModalLoading, setIsModalLoading] = useState(false)
  const [initialFormValues, setInitialFormValues] = useState({});
  const [initialReEditFormValues, setInitialReEditFormValues] = useState({});
  const [abstractHelpData, setAbstractHelpData] = useState({ cn: "", en: "" });
  const [reEditAbstractHelpData, setReEditAbstractHelpData] = useState({ cn: "", en: "" });
  const navigate = useNavigate()
  const location = useLocation()
  const setFuncMap = {
    setIsModalLoading,
    // setFieldsValue: form.setFieldsValue,
    navigate,
    setAbstractHelpData,
    setReEditAbstractHelpData,
    setInitialFormValues,
    setInitialReEditFormValues,
    reEditForm,
    form,
    ...props.setFuncMap
  }
  useEffect(() => {
    setIsModalLoading(true)
    efn.getSubmissionPaperById(props.id, props.conferenceUid, setFuncMap)
    setIsModalLoading(false)
  }, [])
  // useEffect(() => {
  //   form.setFieldsValue(initialFormValues);
  // }, [initialFormValues]);
  // useEffect(() => {
  //   reEditForm.setFieldsValue(initialReEditFormValues);
  // }, [initialReEditFormValues]);
  return (
    <Spin spinning={isModalLoading}>
      {["CREATED", "VERIFY_REJECT"].indexOf(statusCode[initialFormValues.status]) > -1 && <Row gutter={16}>
        <Col span={24}>
          {basicInfo(form, abstractHelpData, efn)}
        </Col>
      </Row>}
      {["WAIT_VERIFY", "REWAIT_VERIFY"].indexOf(statusCode[initialFormValues.status]) > -1 && <Row gutter={16}>
        <Col span={24}>
          <SubmissionPaperAdminAccept status={initialFormValues.status} conferenceUid={props.conferenceUid} setFuncMap={setFuncMap} id={props.id} />
        </Col>
        <Col span={24}>
          {basicInfo(form, abstractHelpData, efn)}
        </Col>
      </Row>}
      {["USER_WAIT_APPROVE_EDITED"].indexOf(statusCode[initialFormValues.status]) > -1 && <Row gutter={16}>
        <Col span={24}>
          <SubmissionPaperAdminReEditAccept status={initialFormValues.status} conferenceUid={props.conferenceUid} setFuncMap={setFuncMap} id={props.id} />
        </Col>
        <Col span={24}>
          {reEditBasicInfo(form, abstractHelpData, reEditForm, reEditAbstractHelpData, efn)}
        </Col>
      </Row>}
      {["SUCCESS", "USER_EDIT_INFO"].indexOf(statusCode[initialFormValues.status]) > -1 &&
        <Row gutter={16} style={{ height: "70vh" }}>
          <Col span={12} style={{ overflow: "auto", height: "100%" }}>
            {basicInfo(form, abstractHelpData, efn)}
          </Col>
          <Col span={11} style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <SubmissionPaperAdminReviewerSetting result={initialFormValues.result} setFuncMap={setFuncMap} id={props.id} conferenceUid={props.conferenceUid} />
          </Col>
        </Row>}
      {["FINALVERSION_REJECT"].indexOf(statusCode[initialFormValues.status]) > -1 &&
        <Row gutter={16}>
          <Col span={24}>
            {basicInfo(form, abstractHelpData, efn)}
          </Col>
        </Row>}
      {["WAIT_FINALVERSION_VERIFY", "REWAIT_FINALVERSION_VERIFY"].indexOf(statusCode[initialFormValues.status]) > -1 && <Row gutter={16}>
        <Col span={24}>
          <SubmissionPaperAdminAccept status={initialFormValues.status} conferenceUid={props.conferenceUid} setFuncMap={setFuncMap} id={props.id} />
        </Col>
        <Col span={24}>
          {basicInfo(form, abstractHelpData, efn)}
        </Col>
      </Row>}
    </Spin>
  );
};

const basicInfo = function (form, abstractHelpData, efn) {
  return <Form
    form={form}
    layout="horizontal"
  >
    <Row gutter={16}>
      <Col span={24}>
        {efn.generateSubmissionPaperAttribute(abstractHelpData).map((item, key) => {
          return <Form.Item key={key} style={{ borderBottom: "1px dotted #848383", alignItems: 'flex-start' }}
            name={item.name}
            label={<span style={{ whiteSpace: 'pre-wrap', display: 'block', fontWeight: 'bold' }}>{item.label}</span>}
            rules={[{ required: item.required, message: `請輸入${item.label}` }, ...item.rules]}
            labelCol={{ span: 24 }}  // 设置 label 的宽度
            wrapperCol={{ span: 24 }} // 设置表单项内容的宽度
          >
            {item.type == "text-tag" ?
              <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >
                {form.getFieldValue(item.name) && form.getFieldValue(item.name).split(";").map((word, k) => {
                  return <Tag color="#868986" key={k}>{word}</Tag>
                })}
              </Typography.Text>
              : <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >{form.getFieldValue(item.name)}</Typography.Text>}

          </Form.Item>
        })}
      </Col>
    </Row>
  </Form>
}

const reEditBasicInfo = function (form, abstractHelpData, reEditForm, reEditAbstractHelpData, efn) {
  return <Row>
    <Col span={12}>
      <Form
        form={form}
        layout="horizontal"
      >
        <Row gutter={16}>
          <Col span={24}>
            {efn.generateSubmissionPaperAttribute(abstractHelpData).map((item, key) => {
              return <Form.Item key={key}
                style={{
                  borderBottom: "1px dotted #848383",
                  alignItems: 'flex-start',
                  borderRadius: '5px',
                  padding: '4px',
                }}
                name={item.name}
                label={<span style={{ whiteSpace: 'pre-wrap', display: 'block', fontWeight: 'bold' }}>{item.label}</span>}
                rules={[{ required: item.required, message: `請輸入${item.label}` }, ...item.rules]}
                labelCol={{ span: 24 }}  // 设置 label 的宽度
                wrapperCol={{ span: 24 }} // 设置表单项内容的宽度
              >
                {item.type == "text-tag" ?
                  <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >
                    {form.getFieldValue(item.name) && form.getFieldValue(item.name).split(";").map((word, k) => {
                      return <Tag color="#868986" key={k}>{word}</Tag>
                    })}
                  </Typography.Text>
                  : <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >{(form.getFieldValue(item.name) || "　")}</Typography.Text>}

              </Form.Item>
            })}
          </Col>
        </Row>
      </Form>
    </Col>
    <Col span={12}>
      <Form
        form={reEditForm}
        layout="horizontal"
      >
        <Row gutter={16}>
          <Col span={24}>
            {efn.generateSubmissionPaperAttribute(reEditAbstractHelpData).map((item, key) => {
              return <Form.Item key={key}
                style={{
                  borderBottom: "1px dotted #848383",
                  alignItems: 'flex-start',
                  borderRadius: '5px',
                  padding: '4px',
                  background: (reEditForm.getFieldValue(item.name) != form.getFieldValue(item.name)) ? '#ff9192' : 'none'
                }}
                name={item.name}
                label={<span style={{ whiteSpace: 'pre-wrap', display: 'block', fontWeight: 'bold' }}>{item.label}</span>}
                rules={[{ required: item.required, message: `請輸入${item.label}` }, ...item.rules]}
                labelCol={{ span: 24 }}  // 设置 label 的宽度
                wrapperCol={{ span: 24 }} // 设置表单项内容的宽度                
              >
                {item.type == "text-tag" ?
                  <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >
                    {reEditForm.getFieldValue(item.name) && reEditForm.getFieldValue(item.name).split(";").map((word, k) => {
                      return <Tag color="#868986" key={k}>{word}</Tag>
                    })}
                  </Typography.Text>
                  : <Typography.Text size="large" style={{ whiteSpace: 'pre-wrap' }} >{(reEditForm.getFieldValue(item.name) || "　")}</Typography.Text>}

              </Form.Item>
            })}
          </Col>
        </Row>
      </Form>
    </Col>
  </Row>
}

export default SubmissionPaperDetailPage;